import PropTypes from "prop-types";
import React from "react";
import {
  CheckmarkCircleIcon,
  CloseIcon,
  PauseIcon,
  PlayIcon,
  TrashCanIcon,
} from "@fluentui/react-icons-northstar";
import { Button } from "@fluentui/react-northstar";

const WidgetControlBar = ({
  currentStep,
  autoConfirm,
  hasTranscript,
  onPause,
  onResume,
  onConfirmClick,
  onClearTranscript,
  onClose,
}) => {
  const renderPrimaryBar = () => (
    <div className="control-bar">
      <Button
        icon={currentStep === "paused" ? <PlayIcon /> : <PauseIcon />}
        onClick={currentStep === "paused" ? onResume : onPause}
        className="control-button"
        title={currentStep === "paused" ? "Start" : "Pause"}
      />
      {!autoConfirm && (
        <Button
          icon={<CheckmarkCircleIcon />}
          onClick={onConfirmClick}
          className="control-button success-button"
          title="Confirm"
        />
      )}
      <Button
        icon={<TrashCanIcon />}
        onClick={onClearTranscript}
        className="control-button"
        title="Clear"
        disabled={!hasTranscript}
      />
      <Button
        icon={<CloseIcon />}
        onClick={onClose}
        className="control-button close-button"
        title="Close"
      />
    </div>
  );

  const renderSimpleClose = () => (
    <div className="control-bar">
      <Button
        icon={<CloseIcon />}
        onClick={onClose}
        className="control-button close-button"
        title="Close"
      />
    </div>
  );

  if (
    currentStep === "listening" ||
    currentStep === "transcribing" ||
    currentStep === "paused"
  ) {
    return renderPrimaryBar();
  }

  if (currentStep === "confirming") {
    return renderSimpleClose();
  }

  return renderSimpleClose();
};

WidgetControlBar.propTypes = {
  autoConfirm: PropTypes.bool.isRequired,
  currentStep: PropTypes.string.isRequired,
  hasTranscript: PropTypes.bool.isRequired,
  onClearTranscript: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  onPause: PropTypes.func.isRequired,
  onResume: PropTypes.func.isRequired,
};

export default WidgetControlBar;

